import { AuthenticationService } from './login/AuthService/auth.service';
import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.html',
})
export class AppComponent {
    constructor(private auth: AuthenticationService) {
    }

    public get authenticated() {
        return this.auth.isAuth();
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts